import { isHeroBrandEnabled } from './heroBrandUtils';

const isContractActive = (contract) => {
  if (!contract) return false;

  if (contract.active === false || contract.isActive === false) {
    return false;
  }

  if (typeof contract.status === 'string' && contract.status.toLowerCase() !== 'active') {
    return false;
  }

  return true;
};

const normalizeContract = (contract) => {
  const id = contract?.id || contract?._id || contract?.contractId || contract?.ContractID;
  const name = contract?.name || contract?.contractName || contract?.title || contract?.Name;

  if (!id) {
    return null;
  }

  return {
    id,
    name: name || String(id),
    // TUL-4996: target (customer) languages this contract allows. Empty => no restriction.
    targetLanguageIds: Array.isArray(contract?.targetLanguageIds) ? contract.targetLanguageIds : [],
    raw: contract,
  };
};

export const getActiveContractsFromUser = (user) => {
  const candidateContracts = user?.Customer?.Contracts
    || user?.customer?.contracts
    || user?.contracts
    || [user?.contract];

  const normalized = candidateContracts
    .filter(isContractActive)
    .map(normalizeContract)
    .filter(Boolean);

  const seen = new Set();
  return normalized.filter((contract) => {
    if (seen.has(contract.id)) {
      return false;
    }
    seen.add(contract.id);
    return true;
  });
};

export const getContractById = (contracts, contractId) => {
  if (!contractId) return null;
  return contracts.find((contract) => String(contract.id) === String(contractId)) || null;
};

// TUL-4996: a contract is orderable only when it allows at least one of the customer's enabled
// target languages. Empty/absent targetLanguageIds means no restriction => always orderable.
// Matching is by languageId (actual language id), mirroring applyContractTargetLanguages.
export const contractAllowsAnyTargetLanguage = (contract, targetLanguages = []) => {
  const allowed = contract?.targetLanguageIds;
  if (!Array.isArray(allowed) || allowed.length === 0) {
    return true;
  }
  return (targetLanguages || []).some((tl) => allowed.includes(tl?.languageId));
};

// TUL-4996: active contracts narrowed to those orderable for the customer's target languages.
// Only herotolk is gated; every other brand keeps the full active list unchanged.
export const getOrderableContractsFromUser = (user) => {
  const active = getActiveContractsFromUser(user);
  if (!isHeroBrandEnabled()) {
    return active;
  }
  return active.filter((contract) => contractAllowsAnyTargetLanguage(contract, user?.targetLanguages));
};

// TUL-4996: block ordering when a herotolk customer has active contracts but none are orderable
// for their target languages. A customer with zero contracts keeps the existing (null-contract) flow.
export const shouldBlockOrdering = (user) => {
  if (!isHeroBrandEnabled()) {
    return false;
  }
  if (getActiveContractsFromUser(user).length === 0) {
    return false;
  }
  return getOrderableContractsFromUser(user).length === 0;
};
